module.exports = __webpack_public_path__ + "static/media/contact_me1.532ff85c.png";